<template>

</template>

<script>
import axios from 'axios';
import { setToken, setUser } from '../utils/auth.js'
export default {
  name: 'OpenAuthRedirectTarget',
  methods: {
    getInfo(code) {
      if (!code) {
        this.$message({
          showClose: true,
          message: '请传入参数',
          type: 'warning',
          duration: 1000
        })
      } else {
        var authtype = localStorage.getItem('authtype')
        console.log(authtype)
        if (authtype === 'wxlogin') {
          var url = '/realNet/vxlogin/getInfo'
        } else if (authtype === 'weibologin') {
          var url = '/realNet/wblogin/getInfo'
        } else if (authtype === 'alilogin') {
          var url = '/realNet/alilogin/getInfo'
        }
        console.log(url)
        var that = this
        let  params = {
          'code': code
        }
        axios({
          url: url,
          method: 'get',
          params: params
        }).then(function (res) {
          console.log(res)
          if (res.data.code === 200) {
            var resdata = res.data.result
            if (resdata.data) {
              that.$store.state.nickname = resdata.nickname
              that.$store.state.data = resdata.data
              that.$message({
                showClose: true,
                message: '授权成功,请先注册',
                type: 'success',
                duration: 1000
              })
              setTimeout(function () {
                that.$router.push({path:'/'})
              },2000)
            } else {
              setToken(resdata.token);
              setUser(JSON.stringify(resdata.user));
              that.$store.state.name = resdata.user.name
              that.$message({
                showClose: true,
                message: '登录成功',
                type: 'success',
                duration: 1000
              })
              setTimeout(function () {
                that.$router.push({path:'/'})
              },2000)
            }
          } else {
            that.$message({
              showClose: true,
              message: res.data.message,
              type: 'warning',
              duration: 1000
            })
          }
        }).catch(function (e) {
          console.log(e)
        })
      }
    }
  },
  mounted() {
    let id = this.$route.query.code
    // let alicode = this.$route.query.auth_code
    if (id) {
      this.getInfo(id)
    }
    // if (alicode) {
    //   this.getInfo(alicode)
    // }
  }
}
</script>

<style scoped>

</style>